import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    token: '',
    userInfo: {},
  },
  reducers: {
    setUser: (state, action) => {
      state.token = action.payload.name;
      state.userInfo = action.payload.userInfo;
    },
    clearUser: (state) => {
      state.token = '';
      state.userInfo = {};
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
